/* email popup session */
document.addEventListener("DOMContentLoaded", function () {
  const backToTopButton = document.getElementById("shopify_scroll-to-top");
  const newsLetter = document.getElementById("shopify_newsLetter");
  const newsLetterClose = document.getElementById("shopify_newsLetter_close");

  if (!backToTopButton || !newsLetter) return; // stop if elements missing

  // Scroll event
  window.addEventListener("scroll", function () {
    const scrolled =
      document.body.scrollTop > 200 || document.documentElement.scrollTop > 200;

    if (scrolled) {
      backToTopButton.style.display = "block";

      // Show popup only if not closed this session
      if (sessionStorage.getItem("shopify_newsletterClosed") !== "true") {
        newsLetter.style.display = "block";
        backToTopButton.style.bottom = "165px";
      } else {
        backToTopButton.style.bottom = "5px";
      }
    } else {
      // When user scrolls back to top
      newsLetter.style.display = "none";
      backToTopButton.style.display = "none";
      backToTopButton.style.bottom = "5px";
    }
  });

  // Smooth scroll to top
  backToTopButton.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  // Close newsletter popup
  if (newsLetterClose) {
    newsLetterClose.addEventListener("click", function (event) {
      event.preventDefault();
      newsLetter.style.display = "none";
      sessionStorage.setItem("shopify_newsletterClosed", "true");
      backToTopButton.style.bottom = "5px";
    });
  }
});


/* end email popup session */

/* Removed: setInterval URL-stripper that was nuking all query params every 2 seconds.
   It was breaking filter URLs (filter.p.*, filter.v.*, sort_by, etc.) and any
   bookmarkable/shareable filtered state. If specific tracking params need to be
   removed in the future, do it by deleting only those params, not the whole search string. */


$(document).ready(function(){
    $('#shopify_shopByBrand').slick({
        autoplay: false,
        autoplaySpeed: 5000,  // Slide duration in milliseconds
        dots: true,           // Show navigation dots
        arrows: false,         // Show next/prev arrows
        slidesToShow: 5,      // Number of slides to show
        slidesToScroll: 1,    // Number of slides to scroll
        centerMode: false,
       responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }]
    });
  $('#shopify_featuredProducts').slick({
        autoplay: false,
        autoplaySpeed: 5000,  // Slide duration in milliseconds
        dots: true,           // Show navigation dots
        arrows: false,         // Show next/prev arrows
        slidesToShow: 4,      // Number of slides to show
        slidesToScroll: 1,    // Number of slides to scroll
        centerMode: false,
       responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }]
    });
/*******************************************/
/*
$('button.slider-button.slider-button--next').click(function () {
    // Find the current active li
    var $activeSlide = $('.product__media-list.contains-media .is-active');
    var $nextSlide = $activeSlide.next('li');
    
    if ($nextSlide.length) {
        // Remove is-active class from current slide
        $activeSlide.removeClass('is-active');

        // Add is-active class to the next slide
        $nextSlide.addClass('is-active');
    } else {
        console.log("No more slides!");
    }
});*/

$('.shopify_product button.slider-button.slider-button--next').click(function (e) {
    e.preventDefault(); // Prevent default action
    e.stopPropagation(); // Stop event propagation

    // Find the current active li
    var $activeSlide = $('.product__media-list.contains-media .is-active');
    var $nextSlide = $activeSlide.next('li');
    var spanval = parseInt($('.slider-counter--current').html()); // Get current counter value
    
    if ($nextSlide.length) {
        // Remove is-active class from current slide
        $activeSlide.removeClass('is-active');

        // Add is-active class to the next slide
        $nextSlide.addClass('is-active');

        // Increment spanval by 1
        $('.slider-counter--current').html(spanval + 1);
    } else {
        // Loop back to the first slide when at the end
        $activeSlide.removeClass('is-active');
        $('.product__media-list.contains-media li').first().addClass('is-active');

        // Reset counter to 1
        $('.slider-counter--current').html(1);
       // console.log('--next');
    }
});

// Previous button functionality
$('.shopify_product button.slider-button.slider-button--prev').click(function (e) {
    e.preventDefault(); // Prevent default action
    e.stopPropagation(); // Stop event propagation

    // Find the current active li
    var $activeSlide = $('.product__media-list.contains-media .is-active');
    var $prevSlide = $activeSlide.prev('li');
    var spanval = parseInt($('.slider-counter--current').html()); // Get current counter value
    
    if ($prevSlide.length) {
        // Remove is-active class from current slide
        $activeSlide.removeClass('is-active');

        // Add is-active class to the previous slide
        $prevSlide.addClass('is-active');

        // Decrement spanval by 1
        $('.slider-counter--current').html(spanval - 1);
    } else {
        // Loop back to the last slide when at the beginning
        $activeSlide.removeClass('is-active');
        $('.product__media-list.contains-media li').last().addClass('is-active');

        // Set counter to the total number of slides
        var totalSlides = $('.product__media-list.contains-media li').length;
        $('.slider-counter--current').html(totalSlides);
        //console.log('--prev');
    }
});


 
});

jQuery(document).ready(function() {
    // Initialize the last scroll position
    let lastScrollLeft = 0;
    let visibleCount = 0; // Counter for visible items
 const totalCount = jQuery('.shopify_sliderMobile.dffd li').length;
  jQuery('.shopify_product .slider-counter--total').text(totalCount);
    // Function to check which li is in view
    function checkVisibleItems() {
        if (!jQuery('.shopify_sliderMobile.dffd').length) return; // 2026-10-24: pages without the PDP mobile slider (homepage) threw here
        const containerOffset = jQuery('.shopify_sliderMobile.dffd').offset().left;
        const containerWidth = jQuery('.shopify_sliderMobile.dffd').width();
        visibleCount = 0; // Reset the visible items count

        // Count all li elements
        const totalCount = jQuery('.shopify_sliderMobile.dffd li').length;
       // console.log('Total number of li items:', totalCount);

        let activeSlideIndex = -1; // Variable to hold the index of the active slide
        jQuery('.shopify_sliderMobile.dffd li').each(function(index) {
            const itemOffset = jQuery(this).offset().left;

            // Check if the item is in the viewport of the container
            if (itemOffset >= containerOffset && itemOffset < (containerOffset + containerWidth)) {
                visibleCount++; // Increment visible items counter
                activeSlideIndex = index; // Store the index of the current visible slide
            } 
        });

        // Log the count of visible items and the active slide index
       // console.log('Number of items currently in view:', visibleCount);
       // console.log('Currently active slide index:', activeSlideIndex+1);
		jQuery('.slider-counter--current').text(activeSlideIndex+1);
		jQuery('.shopify_product .slider-counter--total').text(totalCount);
    }

    // Add an event listener for the scroll event
    jQuery('.shopify_sliderMobile.dffd').on('scroll', function() {
        // Get the current scroll position
        const currentScrollLeft = jQuery(this).scrollLeft();

        // Check if scrolling is going right or left
        if (currentScrollLeft > lastScrollLeft) {
         //   console.log('Scrolling right, currently visible items:', visibleCount);
        } else if (currentScrollLeft < lastScrollLeft) {
          //  console.log('Scrolling left, currently visible items:', visibleCount);
        }

        // Update last scroll position
        lastScrollLeft = currentScrollLeft;

        // Call the function to check which items are visible
        checkVisibleItems();
    });

    // Initial check on load
    checkVisibleItems();
});






/* ═══ YP card photo carousel (2026-10-16) ═══
   Markup in snippets/card-product.liquid, styles in component-card.css.
   One set of delegated listeners serves every card on the page (collection grids
   re-render through the Section Rendering API, so nothing is bound per card).
   Images 2-5 are fetched on a card's first hover / touch / scroll / arrow click, never before. */
(function () {
  if (window.__ypCardCarousel) return;
  window.__ypCardCarousel = true;
  var SEL = '.yp-cc';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function load(cc) {
    if (!cc || cc.dataset.loaded) return;
    cc.dataset.loaded = '1';
    var imgs = cc.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
      img.setAttribute('src', img.dataset.src);
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  }

  function update(cc) {
    var track = cc.querySelector('.yp-cc__track');
    var w = track ? track.clientWidth : 0;
    if (!w) return;
    var n = parseInt(cc.getAttribute('data-count'), 10) || 1;
    var max = track.scrollWidth - w;
    var p = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
    var card = cc.closest('.card');
    var fill = card && card.querySelector('.yp-cc__fill');
    if (fill) fill.style.transform = 'translateX(' + (p * (n - 1) * 100) + '%)';
    var i = Math.round(track.scrollLeft / w);
    var prev = cc.querySelector('.yp-cc__arrow--prev');
    var next = cc.querySelector('.yp-cc__arrow--next');
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i >= n - 1;
  }

  function closestCc(el) {
    return el && el.closest ? el.closest(SEL) : null;
  }

  // first hover (desktop) or first touch (mobile) fetches that card's extra photos
  document.addEventListener('pointerover', function (e) { load(closestCc(e.target)); }, { passive: true });
  document.addEventListener('touchstart', function (e) { load(closestCc(e.target)); }, { passive: true });

  // hover = second photo (owner 2026-10-17): entering a card at photo 1 jumps the strip to photo 2,
  // leaving the card returns it to photo 1. Arrows, swipe and the bar keep working on top of this.
  var hoverCapable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hovered = null;
  function goTo(cc, i) {
    var track = cc.querySelector('.yp-cc__track');
    if (!track || !track.clientWidth) return;
    track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' });
  }
  function cardOf(el) { return el && el.closest ? el.closest('.card-wrapper') : null; }
  if (hoverCapable) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var w = cardOf(e.target);
      if (w === hovered) return;
      if (hovered) { var old = hovered.querySelector(SEL); if (old) goTo(old, 0); }
      hovered = w;
      if (!w) return;
      var cc = w.querySelector(SEL);
      if (!cc) return;
      load(cc);
      var track = cc.querySelector('.yp-cc__track');
      if (track && track.scrollLeft < track.clientWidth / 2) goTo(cc, 1);
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      if (!hovered || cardOf(e.relatedTarget) === hovered) return;
      var cc = hovered.querySelector(SEL);
      if (cc) goTo(cc, 0);
      hovered = null;
    }, { passive: true });
  }

  // scroll does not bubble: one capturing listener, rAF-throttled per strip
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('yp-cc__track')) return;
    load(t.parentNode); // wheel / trackpad / keyboard scrolls fire no hover or touch
    if (t.__ypRaf) return;
    t.__ypRaf = requestAnimationFrame(function () {
      t.__ypRaf = 0;
      update(t.parentNode);
    });
  }, true);

  // arrows: never follow the card link
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.yp-cc__arrow') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var cc = btn.closest(SEL);
    load(cc);
    var track = cc.querySelector('.yp-cc__track');
    var w = track.clientWidth;
    var n = parseInt(cc.getAttribute('data-count'), 10) || 1;
    var i = Math.round(track.scrollLeft / w) + (btn.classList.contains('yp-cc__arrow--next') ? 1 : -1);
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * w, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
